import { Customer } from "@/models/response/customer";
import { ActionIcon, Avatar, Card, Group, Stack, Text } from "@mantine/core";
import { IconUserPlus } from "@tabler/icons-react";

type Props = {
  selectedCustomer: Customer | null;
  openCustomer?: () => void;
};

function CustomerInfo({ selectedCustomer, openCustomer }: Props) {
  return (
    <Card withBorder onClick={openCustomer}>
      {selectedCustomer ? (
        <Group justify="space-between">
          <Stack gap="5">
            <Text size="sm" fw="500">
              {selectedCustomer?.phoneNumber}
            </Text>
            <Text size="xs" c="dimmed">
              {selectedCustomer?.firstName} {selectedCustomer?.lastName}
            </Text>
          </Stack>
          <Avatar variant="light" color="blue" size="md">
            {selectedCustomer?.firstName?.charAt(0) || ""}
          </Avatar>
        </Group>
      ) : (
        <Group justify="space-between">
          <Stack gap="5">
            <Text size="sm" fw="500">
              افزودن مشتری
            </Text>
            <Text size="xs" c="dimmed">
              مشتری خود راانتخاب و یا اضافه نماید
            </Text>
          </Stack>
          <ActionIcon variant="light" radius="xl" size="xl">
            <IconUserPlus />
          </ActionIcon>
        </Group>
      )}
    </Card>
  );
}

export default CustomerInfo;
